;; ============================================================================
;; AUTO-GENERATED — Developer Preview Page
;; This file is auto-generated for developer data inspection purposes.
;; It is NOT intended to be maintained as production UI.
;; ============================================================================
(ns hai.library.connections.linear-preview
  (:require
   [hai.library.connections.disposable-ui :as dui]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e defevent defevent-fx defsub]]
   [hai.web-app.layout :as layout]
   [reagent.core :as r]))

;; ---------------------------------------------------------------------------
;; EQL Queries — Developer Reference
;;
;; These functions build EQL queries for Linear resolvers.
;; pathom3-graphql auto-generates resolvers from Linear's static GraphQL
;; schema, so all query and mutation patterns map directly to GraphQL types.
;;
;; See: projects/platform/src/hai/pathom/linear.clj
;; ---------------------------------------------------------------------------

(def team-attrs
  [:linear.Team/id :linear.Team/name :linear.Team/key])

(def issue-attrs
  [:linear.Issue/id
   :linear.Issue/identifier
   :linear.Issue/title
   :linear.Issue/priority
   {:linear.Issue/state [:linear.WorkflowState/name :linear.WorkflowState/type]}
   {:linear.Issue/assignee [:linear.User/name]}])

(defn teams-with-issues-query []
  [{:linear.Query/teams
    [{:linear.TeamConnection/nodes
      (into team-attrs
            [{:linear.Team/issues
              [{:linear.IssueConnection/nodes issue-attrs}]}])}]}])

(defn create-issue-mutation [team-id title priority]
  [{(list 'linear.Mutation/issueCreate
          {:input {:title title :teamId team-id :priority priority}})
    [:linear.IssuePayload/success
     {:linear.IssuePayload/issue
      [:linear.Issue/id :linear.Issue/identifier :linear.Issue/title]}]}])

;; ---------------------------------------------------------------------------
;; Priority helpers
;; ---------------------------------------------------------------------------

(def priority-labels
  {0 "No priority"
   1 "Urgent"
   2 "High"
   3 "Medium"
   4 "Low"})

(def priority-colors
  "CSS color pairs [bg, fg] per priority level."
  {0 ["var(--gray-3)" "var(--gray-11)"]
   1 ["var(--red-3)" "var(--red-11)"]
   2 ["var(--amber-3)" "var(--amber-11)"]
   3 ["var(--blue-3)" "var(--blue-11)"]
   4 ["var(--gray-3)" "var(--gray-11)"]})

(def state-type-colors
  "CSS color pairs [bg, fg] per workflow state type."
  {"started"   ["var(--amber-3)" "var(--amber-11)"]
   "completed" ["var(--green-3)" "var(--green-11)"]
   "cancelled" ["var(--red-3)" "var(--red-11)"]
   "backlog"   ["var(--gray-3)" "var(--gray-11)"]
   "unstarted" ["var(--blue-3)" "var(--blue-11)"]
   "triage"    ["var(--violet-3)" "var(--violet-11)"]})

;; ---------------------------------------------------------------------------
;; Subscriptions
;; ---------------------------------------------------------------------------

(defsub ::connection-uuid [db]
  (get-in db [:routing/current-route :path-params :connection/uuid]))

(defsub ::teams [db]
  (::teams db))

(defsub ::selected-team-id [db]
  (::selected-team-id db))

(defsub ::issues [db]
  (::issues db))

(defsub ::loading? [db]
  (::loading? db))

(defsub ::error [db]
  (::error db))

(defsub ::create-title [db]
  (or (::create-title db) ""))

(defsub ::create-priority [db]
  (or (::create-priority db) 4))

(defsub ::creating? [db]
  (::creating? db))

(defsub ::create-error [db]
  (::create-error db))

(defsub ::card-view? [db]
  (if (contains? db ::card-view?)
    (::card-view? db)
    true))

;; ---------------------------------------------------------------------------
;; Events
;; ---------------------------------------------------------------------------

(defevent-fx ::fetch-teams
  [{:keys [db]} conn-uuid]
  {:db (assoc db ::loading? true)
   :fetch {:url "/resolve"
           :method :post
           :body {:query (teams-with-issues-query)
                  :options {:connection/uuid (uuid conn-uuid)}}
           :on-success-fx [[:dispatch [::teams-loaded '?body]]]
           :on-error-fx [[:dispatch [::fetch-error '?body]]]}})

(defevent ::fetch-error [db response]
  (-> db
      (assoc ::loading? false)
      (assoc ::error (or (:com.wsscode.pathom3.error/error-message response)
                         (str response)))))

(defevent ::teams-loaded [db response]
  (let [error-msg (:com.wsscode.pathom3.error/error-message response)
        teams (get-in response [:linear.Query/teams :linear.TeamConnection/nodes])
        issues-by-team (into {}
                             (map (fn [team]
                                    [(:linear.Team/id team)
                                     (get-in team [:linear.Team/issues
                                                   :linear.IssueConnection/nodes])]))
                             teams)
        selected (::selected-team-id db)]
    (-> db
        (assoc ::teams teams)
        (assoc ::issues-by-team issues-by-team)
        (assoc ::error error-msg)
        (assoc ::loading? false)
        (cond->
         selected (assoc ::issues (get issues-by-team selected))))))

(defevent ::select-team [db team-id]
  (let [issues (get-in db [::issues-by-team team-id])]
    (-> db
        (assoc ::selected-team-id team-id)
        (assoc ::issues issues))))

(defevent ::update-create-title [db title]
  (assoc db ::create-title title))

(defevent ::update-create-priority [db priority]
  (assoc db ::create-priority priority))

(defevent-fx ::create-issue
  [{:keys [db]}]
  (let [team-id (::selected-team-id db)
        title (::create-title db)
        priority (::create-priority db)
        conn-uuid (get-in db [:routing/current-route :path-params :connection/uuid])]
    (if (or (empty? title) (nil? team-id))
      {:db db}
      {:db (-> db
               (assoc ::creating? true)
               (assoc ::create-error nil))
       :fetch {:url "/resolve"
               :method :post
               :body {:query (create-issue-mutation team-id title priority)
                      :options {:connection/uuid (uuid conn-uuid)}}
               :on-success-fx [[:dispatch [::issue-created '?body]]]
               :on-error-fx [[:dispatch [::create-failed '?body]]]}})))

(defevent ::issue-created [db response]
  (let [result (get response 'linear.Mutation/issueCreate)
        success? (:linear.IssuePayload/success result)
        new-issue (:linear.IssuePayload/issue result)
        team-id (::selected-team-id db)]
    (if success?
      (-> db
          (assoc ::creating? false)
          (assoc ::create-title "")
          (assoc ::create-error nil)
          ;; Prepend new issue to current team's list
          (update-in [::issues-by-team team-id] #(into [new-issue] %))
          (update ::issues #(into [new-issue] %)))
      (-> db
          (assoc ::creating? false)
          (assoc ::create-error "Create failed — check platform logs")))))

(defevent ::toggle-card-view [db]
  (update db ::card-view? not))

(defevent ::create-failed [db response]
  (-> db
      (assoc ::creating? false)
      (assoc ::create-error (or (:com.wsscode.pathom3.error/error-message response)
                                (str response)))))

;; ---------------------------------------------------------------------------
;; View Components
;; ---------------------------------------------------------------------------

(defn priority-badge-view
  "Renders a color-coded priority badge."
  [priority]
  (let [label (get priority-labels priority "?")
        [bg fg] (get priority-colors priority ["var(--gray-3)" "var(--gray-11)"])]
    [dui/priority-badge {:style {:background bg :color fg}}
     label]))

(defn state-badge-view
  "Renders a workflow state pill colored by type."
  [state]
  (let [state-name (:linear.WorkflowState/name state)
        state-type (:linear.WorkflowState/type state)
        [bg fg] (get state-type-colors state-type ["var(--gray-3)" "var(--gray-11)"])]
    [dui/state-badge {:style {:background bg :color fg}}
     (or state-name "—")]))

(defn issue-card
  "Card view for a single issue."
  [issue]
  [dui/friendly-card
   [dui/friendly-card-title
    [:span {:style {:font-family "monospace" :margin-right "6px"
                    :color "var(--gray-9)" :font-size "12px"}}
     (:linear.Issue/identifier issue)]
    (or (:linear.Issue/title issue) "(No title)")]
   [dui/friendly-field
    [dui/friendly-label "Priority"]
    [priority-badge-view (:linear.Issue/priority issue)]]
   (when-let [state (:linear.Issue/state issue)]
     [dui/friendly-field
      [dui/friendly-label "State"]
      [state-badge-view state]])
   (when-let [assignee (:linear.Issue/assignee issue)]
     [dui/friendly-field
      [dui/friendly-label "Assignee"]
      [dui/friendly-value (or (:linear.User/name assignee) "—")]])])

(defn control-bar []
  (r/with-let [!issues (<s [::issues])
               !card-view? (<s [::card-view?])]
    [dui/filter-bar
     [dui/view-toggle
      [dui/toggle-label "Cards"]
      [c/Switch {:checked (boolean @!card-view?)
                 :on-checked-change #(>e [::toggle-card-view])}]]
     (when-let [issues @!issues]
       [dui/event-count-text (str "Showing " (count issues) " issues")])]))

(defn issue-map-view [issue]
  [dui/event-card
   [dui/event-title
    (str (:linear.Issue/identifier issue) " "
         (or (:linear.Issue/title issue) "(No title)"))]
   [dui/attr-table (dissoc issue :linear.Issue/title :linear.Issue/identifier)]])

(defn create-issue-form
  "Inline form to create a new issue for the selected team."
  []
  (r/with-let [!title (<s [::create-title])
               !priority (<s [::create-priority])
               !creating? (<s [::creating?])
               !error (<s [::create-error])]
    [:div
     [dui/section-heading "Create Issue"]
     [dui/inline-form
      [:label {:style {:font-size "12px" :color "var(--gray-11)"}} "Title"]
      [dui/text-input {:type "text"
                       :placeholder "Issue title..."
                       :value @!title
                       :disabled @!creating?
                       :on-change #(>e [::update-create-title (.. % -target -value)])
                       :on-key-down #(when (= "Enter" (.-key %))
                                       (>e [::create-issue]))}]
      [:label {:style {:font-size "12px" :color "var(--gray-11)"}} "Priority"]
      [dui/select-input {:value (str @!priority)
                         :disabled @!creating?
                         :on-change #(>e [::update-create-priority
                                          (js/parseInt (.. % -target -value) 10)])}
       [:option {:value "0"} "No priority"]
       [:option {:value "1"} "Urgent"]
       [:option {:value "2"} "High"]
       [:option {:value "3"} "Medium"]
       [:option {:value "4"} "Low"]]
      [dui/apply-btn {:on-click #(>e [::create-issue])
                      :disabled @!creating?}
       (if @!creating? "Creating..." "Create")]]
     (when @!error
       [:div {:style {:margin-top "8px"}}
        [dui/error-text @!error]])]))

(defn team-list-panel []
  (r/with-let [!teams (<s [::teams])
               !selected (<s [::selected-team-id])
               !loading? (<s [::loading?])
               !error (<s [::error])]
    [dui/left-panel
     [dui/section-heading "Teams"]
     (cond
       @!loading?
       [dui/loading-text "Loading teams..."]

       @!error
       [dui/error-text @!error]

       (empty? @!teams)
       [dui/empty-state "No teams found"]

       :else
       (let [selected @!selected]
         (for [team @!teams
               :let [team-id (:linear.Team/id team)]]
           ^{:key team-id}
           [dui/list-item
            {:class (when (= team-id selected) "selected")
             :on-click #(>e [::select-team team-id])}
            [dui/list-item-title
             (:linear.Team/name team)]
            [dui/list-item-meta
             (:linear.Team/key team)]])))]))

(defn issues-panel []
  (r/with-let [!issues (<s [::issues])
               !loading? (<s [::loading?])
               !selected (<s [::selected-team-id])
               !teams (<s [::teams])
               !card-view? (<s [::card-view?])]
    (let [card-view? @!card-view?]
      [dui/right-panel
       (if-not @!selected
         [dui/empty-state "Select a team to view its issues"]
         [:<>
          (let [team (some #(when (= (:linear.Team/id %) @!selected) %) @!teams)]
            (when team
              [:div.mb-4
               [dui/section-heading "Team Details"]
               [dui/attr-table (dissoc team :linear.Team/issues)]]))
          [control-bar]
          [dui/section-heading "Issues"]
          (cond
            @!loading?
            [dui/loading-text "Loading issues..."]

            (empty? @!issues)
            [dui/empty-state "No issues found"]

            :else
            [:div {:style {:display "flex" :flex-direction "column" :gap "8px"}}
             (for [issue @!issues
                   :let [issue-id (or (:linear.Issue/id issue) (random-uuid))]]
               ^{:key issue-id}
               (if card-view?
                 [issue-card issue]
                 [issue-map-view issue]))])
          [create-issue-form]])])))

;; ---------------------------------------------------------------------------
;; Page
;; ---------------------------------------------------------------------------

(defn page [_]
  (r/with-let [!conn-uuid (<s [::connection-uuid])]
    (>e [::fetch-teams @!conn-uuid])
    (fn [_]
      [layout/page
       [layout/breadcrumbs]
       [layout/heading {:label "Linear Explorer"}]
       [layout/content
        [dui/explorer-layout
         [team-list-panel]
         [issues-panel]]]])))
